/* eslint-disable @typescript-eslint/prefer-for-of */
import { DSNCTable, DSTableCell } from 'shared-definitions/types'
import { ApiComponentTable } from 'data-source/types.wp'
import { pLinkExternalMapper } from './pLinkMapper'

export function ncTable(input: ApiComponentTable): DSNCTable | [] {
  if (input.table.length <= 1) {
    return []
  }

  const [headings, ...cells] = input.table

  return {
    resource: 'nc-table',
    pLinkEdit: input.edit_url ? pLinkExternalMapper(input.edit_url) : null,
    headings: headings.map((html, colIndex) => ({ html, colIndex })).map(normalizeCell),
    cells: mapRows(cells.map(mapCells)).map(r => r.map(normalizeCell)),
  }
}

const colSpan = '#colspan#'
const rowSpan = '#rowspan#'

function mapCells(input: string[]): DSTableCell[] {
  const result: DSTableCell[] = []

  let tmpRow: DSTableCell = { html: '', colIndex: 0 }
  for (let i = 0; i < input.length; i++) {
    const item = input[i]
    if (item === colSpan) {
      tmpRow.cols = tmpRow.cols ? tmpRow.cols + 1 : 2
    } else {
      tmpRow = { html: item, colIndex: i }
      result.push(tmpRow)
    }
  }

  return result
}

function mapRows(input: DSTableCell[][]): DSTableCell[][] {
  const result: DSTableCell[][] = [...input]

  for (let rowIndex = 0; rowIndex < result.length; rowIndex++) {
    const row = result[rowIndex]

    for (let cellIndex = 0; cellIndex < row.length; cellIndex++) {
      const cell = row[cellIndex]

      if (cell.html === rowSpan) {
        if (rowIndex > 0) {
          // 1. add rows counter to prev row & same cell
          const prevCell = result[rowIndex - 1][cellIndex]
          prevCell.rows = prevCell.rows ? prevCell.rows + 1 : 2

          // 2. set value from previous row
          result[rowIndex][cellIndex].hidden = true
          result[rowIndex][cellIndex].html = result[rowIndex - 1][cellIndex].html
        }
      }
    }
  }

  return result
}

// /camera-shootout-results-690429/
function normalizeCell(input: DSTableCell): DSTableCell {
  if ([colSpan, rowSpan].includes(input.html)) {
    input.html = ''
  }
  return input
}
